export const QUOTE_EXPIRATION_DAYS = 15;
